<template>
  <div v-if="ready" class="mb-2">
    <div v-if="profile" id="miperfil" class="userBox flex items-center" @click="showProfile">
      <div class="flex flex-1 items-top">
        <img :src="avatar" class="avatar" />
        <div class="flex-1 flex flex-col ml-2 labels mt-1">
          <label class="flex-1 text-sm userName smallerSize1">{{profile.name}}</label>
          <label class="flex-1 text-xs userTrees smallerSize2 mt-1">{{trees}} {{trees == 1 ? $t('arbol')  : $t('arboles')}}</label>
        </div>
      </div>
      <i class="icon icon-arrow-right arrow px-4" />
    </div>
    <div v-else class="registerBox">
      <div class="flex items-center ml-2 mt-1">
        <img src="../../assets/images/profile.svg" class="avatar  mr-3" style="width:65px;" />
        <label>{{ $t('accede') }}</label>
      </div>
      <button id="registroizquierdo" class="btn btn-primary w-full mt-3 mb-1" @click="showLogin"> {{ $t('register') }}</button>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import { isMobile } from '@/utils'
  export default {
    name: 'AsideUser',
    data() {
      return {
      }
    },
    computed: {
      ...mapState('auth', ['ready', 'user', 'profile']),
      trees() {
        return this.$store.getters.userTrees(this.$store.state.auth.user.uid)
      },
      avatar() {
        if (this.profile.image) {
          return this.profile.image
        } else {
          return require('@/assets/images/profile.svg')
        }
      }
    },
    methods: {
      showLogin() {
        this.$store.dispatch('auth/showSession', true)
      },
      showProfile() {
        // if (isMobile() && this.$route.path !== '/') {
        //   this.$router.replace('/me')
        // } else {
        //   this.$router.push('/me')
        // }
        this.$router.push('/me')
      }
    },
    created() {

    }
  }
</script>

<style lang="scss">
  @import '@/style/_variables.scss';
  .registerBox {
    border-radius: 4px;
    background-color: #edf2b4;
    padding: 0.65rem;
    label {
      font-size: 14px;
      font-weight: 300;
      color: $almost-black;
    }
  }
  .userBox {
    min-height: 64px;
    border-radius: 32px;
    background-color: rgba(210,236,108,0.3);
    border-color: #ADD33A;
    img.avatar {
      margin-left: 1px;
      width: 60px;
      height: 60px;
      border-radius: 30px;
    }
    .labels {
      max-width: 140px;
      .ranking {
        img {
          width: 8px;
          height: 8px;
          background-color: $gray-color;
        }
      }
    }
    img.arrow {
      width: 8px;
      height: 12px;
      background-color: $gray-color;
    }
  }
  .smallerSize1 {
    font-size: 16px !important;
    margin-top: 2px;
  }
  .smallerSize2 {
    font-size: 13px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/aside/AsideUser.vue